export class TableSpinerReloadActive {
    public static readonly type = '[TableReload] Show';
}
export class  TableSpinerReloadHide {
    public static readonly type = '[TableReload] Hide';
}
